// ... existing code ...
import Cookies from "js-cookie";
import {useEffect} from "react";

export const logout = () => {
    Cookies.remove('user');
    Cookies.remove('level');
    Cookies.remove('database');
    Cookies.remove('name');
    window.location.href = "/"; // Redirect to login
};

export const useIdleTimers = (timeoutInMinutes = 20) => {
    const timeout = timeoutInMinutes * 60 * 1000;

    useEffect(() => {
        let timer;

        const resetTimer = () => {
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => {
                const user = Cookies.get('user');
                if (user) {
                    logout();
                }
            }, timeout);
        };

        // Events to listen for
        const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];

        events.forEach(event => document.addEventListener(event, resetTimer));

        // Initialize timer
        resetTimer();

        return () => {
            events.forEach(event => document.removeEventListener(event, resetTimer));
            if (timer) clearTimeout(timer);
        };
    }, [timeout]);
};